/* eslint-disable */
import * as Types from '../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../features/attachments/Attachments.generated.js';
import { ContactPersonFragmentDoc } from '../auth/UserDataProvider.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RefTokenQueryVariables = Types.Exact<{
  refToken: Types.Scalars['String']['input'];
}>;


export type RefTokenQuery = { referralInfo?: { __typename: 'ReferralInfo', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } | null, organisationMembershipInvitation?: { __typename: 'OrganisationMembershipInvitation', id: string, status: Types.OrganisationMembershipInvitationStatus, invitationToken: string, organisation: { __typename: 'OrganisationMembershipInvitationOrganisation', id: string, name: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, user: { __typename: 'OrganisationMembershipInvitationUser', id: string, title: string, email: string, firstname: string, familyname: string }, author: { __typename: 'User', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } } | null, projectContracteeInvitation?: { __typename: 'ProjectContracteeInvitation', id: string, title: string, status: Types.InvitationState, invitationToken: string, messageBody: string, projectId: string, contact: { __typename: 'InvitationContact', id: string, title: Types.Salutation, company: string, firstname: string, familyname: string, email: any, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, author: { __typename: 'Person', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, company: { __typename: 'Company', id: string, title: string, description: string, website: string, isMeister: boolean, contactPerson?: { __typename: 'Person', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } } } | null, crmLinkingInvitation?: { __typename: 'CrmLinkingInvitation', id: string, token: string, authorOrganisation: { __typename: 'CrmLinkingInvitationAuthorOrganisation', id: string, name: string }, contact: { __typename: 'CrmLinkingInvitationContact', id: string, company: string, email: any, person?: { __typename: 'CrmLinkingInvitationContactPerson', title: Types.Salutation, firstname: string, familyname: string } | null } } | null };

export type InvitationContactFragment = { __typename: 'InvitationContact', id: string, title: Types.Salutation, company: string, firstname: string, familyname: string, email: any, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null };

export const InvitationContactFragmentDoc = gql`
    fragment InvitationContact on InvitationContact {
  id
  title
  company
  firstname
  familyname
  email
  logo {
    ...AttachmentSnapshot
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export const RefTokenDocument = gql`
    query RefToken($refToken: String!) {
  referralInfo(refToken: $refToken) {
    id
    title
    logo {
      ...AttachmentSnapshot
    }
  }
  organisationMembershipInvitation(refToken: $refToken) {
    id
    status
    invitationToken
    organisation {
      id
      name
      title
      logo {
        ...AttachmentSnapshot
      }
    }
    user {
      id
      title
      email
      firstname
      familyname
    }
    author {
      id
      avatar {
        ...AttachmentSnapshot
      }
      title
      description
      website
      isMeister
      familyname
      firstname
      fullname
      locale
    }
  }
  projectContracteeInvitation(refToken: $refToken) {
    id
    title
    status
    invitationToken
    messageBody
    projectId
    contact {
      ...InvitationContact
    }
    author {
      id
      title
      description
      website
      isMeister
      familyname
      firstname
      fullname
      locale
      company {
        id
        title
        description
        website
        isMeister
        contactPerson {
          id
          ...ContactPerson
        }
        logo {
          ...AttachmentSnapshot
        }
      }
    }
  }
  crmLinkingInvitation(refToken: $refToken) {
    id
    token
    authorOrganisation {
      id
      name
    }
    contact {
      id
      company
      email
      person {
        title
        firstname
        familyname
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}
${InvitationContactFragmentDoc}
${ContactPersonFragmentDoc}`;

/**
 * __useRefTokenQuery__
 *
 * To run a query within a React component, call `useRefTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefTokenQuery({
 *   variables: {
 *      refToken: // value for 'refToken'
 *   },
 * });
 */
export function useRefTokenQuery(baseOptions: Apollo.QueryHookOptions<RefTokenQuery, RefTokenQueryVariables> & ({ variables: RefTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RefTokenQuery, RefTokenQueryVariables>(RefTokenDocument, options);
      }
export function useRefTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RefTokenQuery, RefTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RefTokenQuery, RefTokenQueryVariables>(RefTokenDocument, options);
        }
export function useRefTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RefTokenQuery, RefTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RefTokenQuery, RefTokenQueryVariables>(RefTokenDocument, options);
        }
export type RefTokenQueryHookResult = ReturnType<typeof useRefTokenQuery>;
export type RefTokenLazyQueryHookResult = ReturnType<typeof useRefTokenLazyQuery>;
export type RefTokenSuspenseQueryHookResult = ReturnType<typeof useRefTokenSuspenseQuery>;
export type RefTokenQueryResult = Apollo.QueryResult<RefTokenQuery, RefTokenQueryVariables>;